<!-- History Modal -->
<nz-modal
  [(nzVisible)]="showModal"
  nzTitle="{{ modalTitle }} History"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzWidth]="900"
  (nzOnCancel)="handleCancel()"
>
  <ng-template #modalContent>
    <div class="grid-container>">
      <nz-table
        #rowSelectionTable
        [nzData]="gridData"
        [nzLoading]="loading"
        nzShowPagination
        [nzFrontPagination]="false"
        [(nzScroll)]="gridSize"
        [nzWidthConfig]="widthConfig"
        nzSize="middle"
        nzShowSizeChanger
        [(nzPageIndex)]="currentPageIndex"
        [(nzPageSize)]="currentPageSize"
        [nzPageSizeOptions]="[10]"
        [nzShowTotal]="totalTemplate"
        [nzTotal]="total"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"

      >
        <thead>
          <tr>
            <th
              *ngFor="let col of gridColumnList"
              [nzAlign]="'left'"
              class="ant-table-column-title"
            >
              <span>{{ col.header }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of gridData">
            <td
              *ngFor="let colObj of gridColumnFields"
              class="ant-table-row-data {{ colObj.class }}"
            >
              <span
                *ngIf="colObj.tooltip === true"
                nz-tooltip
                nzTooltipTitle="{{ data[colObj.field] }}"
                >{{ data[colObj.field] }}</span
              >
              <span *ngIf="colObj.tooltip === false">{{
                data[colObj.field]
              }}</span>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <ng-template #totalTemplate let-total let-range="range">
        {{ range[0] }} to {{ range[1] }} of {{ total }}
      </ng-template>
    </div>
  </ng-template>
  <ng-template #modalFooter>
    <div class="modal-footer text-align-center">
      <button nz-button nzType="default" (click)="handleCancel()">
        Cancel
      </button>
    </div>
  </ng-template>
</nz-modal>
